module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx fx-y-center"
  }, [(_vm.title) ? _c('div', {
    staticClass: "fx w120 m-r-5"
  }, [_c('p', {
    staticClass: "ask-cont"
  }, [(_vm.isMust) ? _c('i', {
    staticClass: "ask"
  }, [_vm._v("*")]) : _vm._e()]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fx-fill select-cont"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "input b-r-5",
    attrs: {
      "placeholder": "请选择",
      "disabled": false
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handleChange]
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-fae56fd8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/zui/Select.vue
// module id = 896
// module chunks = 0